import {
  INPUT_CHANGE,
  GET_ROLES_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  CLEAR_FORM,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  PASSWORD_CHANGE_SUCCESS,
  SOCIAL_LOGIN_UPDATE_SUCCESS,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  CHECK_USER_AND_JOIN_CLASS_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
  PASSWORD_CHANGE_FROM_PROFILE_SUCCESS,
  LOGOUT_SUCCESS,
  UPDATE_PROFILE_PIC_SUCCESS,
  LOAD_USER_SUCCESS,
  LOAD_USER_START
} from "../actions/types";

const initialState = {
  drop: false,
  searchRedirect: false,
  redirect: false,
  location: localStorage.getItem("location"),
  chartSection: "subject",
  searchLocation: "/search",
  isAuthenticated: false,
  inClass: false,
  targetUser: null,
  role: "",
  activeEnrolledCourseId: "",
  activeCourseId: "",
  activeCourseName: "",
  fullName: "",
  email: "",
  password: "",
  confirmPassword: "",
  referralCode: "",
  passwordMode: true,
  roles: [
    { _id: "605b11c92bb1d23ddc58f1d2", name: "Staff" },
    { _id: "605b11e72bb1d23ddc58f1d3", name: "Moderator" },
    { _id: "605b11ff2bb1d23ddc58f1d4", name: "Admin" },
  ],
  classes: [],
  classLabel: "Select a Class",
  userId: "",
  user: {},
  courseId: "",
  address: "unknown",
  activeCoursePaidStatus: false,
  dashboardRoute: false,
  className: "",
  students: 0,
  teachers: 0,
  numberOfClassNote: 0,
  numberOfQuizQuestions: 0,
  loadingUser: false,
  state: "",
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case INPUT_CHANGE:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };

    case CHECK_USER_AND_JOIN_CLASS_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
      };
    case GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: action.payload.roles,
        classes: action.payload.courses,
        students: action.payload.students,
        teachers: action.payload.teachers,
        numberOfClassNote: action.payload.numberOfClassNote,
        numberOfQuizQuestions: action.payload.numberOfQuizQuestions,
      };

    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
    case AUTH_SUCCESS:
    case SOCIAL_LOGIN_UPDATE_SUCCESS:
      let myObj = {};
      let otherObj = {};

      if(!action.payload.user) return state;

      if (action.payload.token) {
        localStorage.setItem("token", action.payload.token);
      }

      if (!action.payload.user.role) {
        myObj = {
          isAuthenticated: false,
          location: "/social-login",
        };
      } else {
        if (action.payload.user.role === "605b11c92bb1d23ddc58f1d2") {
          myObj = {
            isAuthenticated: true,
            location: "/dashboard",
          };
        } else if (action.payload.user.role === "605b11e72bb1d23ddc58f1d3") {
          myObj = {
            isAuthenticated: true,
            location: "/dashboard",
          };
        } else if ((action.payload.user.role = "605b11ff2bb1d23ddc58f1d4")) {
          myObj = {
            isAuthenticated: true,
            location: "/dashboard",
          };
        }
      }
      otherObj = {
        userId: action.payload.user._id,
        user: action.payload.user,
        redirect: true,
        email: action.payload.user.email,
        fullName: action.payload.user.fullName,
        role: action.payload.user.role ? action.payload.user.role : "",
        state: action.payload.user.state ? action.payload.user.state : "",
      };

      return {
        ...state,
        ...myObj,
        ...otherObj,
      };

    case LOAD_USER_SUCCESS:
      let loadObj = {};
      let otherLoadObj = {};

      if(!action.payload.user) return state;

      if (!action.payload.user.role) {
        loadObj = {
          isAuthenticated: false,
          location: "/",
        };
      } else {
        if (action.payload.user.role === "605b11c92bb1d23ddc58f1d2") {
          loadObj = {
            isAuthenticated: true,
            location: "/dashboard",
          };
        } else if (action.payload.user.role === "605b11e72bb1d23ddc58f1d3") {
          loadObj = {
            isAuthenticated: true,
            location: "/dashboard",
          };
        } else if ((action.payload.user.role = "605b11ff2bb1d23ddc58f1d4")) {
          loadObj = {
            isAuthenticated: true,
            location: "/dashboard",
          };
        }
      }
      otherLoadObj = {
        userId: action.payload.user._id,
        user: action.payload.user,
        redirect: true,
        email: action.payload.user.email,
        fullName: action.payload.user.fullName,
        role: action.payload.user.role ? action.payload.user.role : "",
        state: action.payload.user.state ? action.payload.user.state : "",
        loadingUser: false
      };

      return {
        ...state,
        ...loadObj,
        ...otherLoadObj,
      };

    case CLEAR_FORM:
      return {
        ...state,
        role: "",
        fullName: "",
        email: "",
        password: "",
        referralCode: "",
        passwordMode: true,
      };

    case REGISTER_FAILURE:
    case LOGIN_FAILURE:
    case AUTH_FAILURE:
      localStorage.removeItem("token");
      localStorage.setItem("location", "/");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: {},
      };
    case PASSWORD_CHANGE_SUCCESS:
      return {
        ...state,
        password: "",
        confirmPassword: "",
      };
    case PASSWORD_CHANGE_FROM_PROFILE_SUCCESS:
      return {
        ...state,
        password: "",
        confirmPassword: "",
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
      };
    case UPDATE_PROFILE_PIC_SUCCESS:
      return {
        ...state,
      };
    case LOGOUT_SUCCESS:
      localStorage.removeItem("token");
      return {
        ...state,
        drop: false,
        searchRedirect: false,
        redirect: false,
        location: "",
        chartSection: "subject",
        searchLocation: "/search",
        isAuthenticated: false,
        role: "",
        activeEnrolledCourseId: "",
        activeCourseId: "",
        activeCourseName: "",
        fullName: "",
        email: "",
        password: "",
        confirmPassword: "",
        referralCode: "",
        passwordMode: true,
        classLabel: "Select a Class",
        userId: "",
        user: {},
        courseId: "",
        address: "unknown",
        activeCoursePaidStatus: false,
        dashboardRoute: false,
        className: "",
      };
      case LOAD_USER_START:
        return{
          ...state,
          loadingUser: true
        }
    default:
      return state;
  }
};
export default authReducer;
